import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { IntlProvider } from 'react-intl';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorker from './serviceWorker';
import ContainerRouter from './router.js';
import configureStore, { history, persistor } from './reducks/store';
import localeMessages from './locale/index.js';
import GlobalIntlProvider from './core/globalIntl.js';
import axios from 'axios';
import { debugLogRequest, debugLogResponse, requestURL, getFunctionName, getStub } from './lib/api';
import config from './config/config.js';

import { commonOperations } from './reducks/common';
const reduxStore = configureStore(window.REDUX_INITIAL_DATA);
const { dispatch } = reduxStore;
const persistorStore = persistor(reduxStore);

if(!config.consoleLogFlag){
  console.log = () => {};
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

axios.defaults.validateStatus = (status) => {
  return true;
};

axios.interceptors.request.use((request) => {
  dispatch(commonOperations.startRequest());
  request = requestURL(request);
  dispatch(commonOperations.checkAccessOperation());
  debugLogRequest(request);
  if (config.apiStubFlag) {
    var stub = getStub(getFunctionName(request.url));
    if (stub !== "") {
      return Promise.reject(stub);
    }
  }
  return request;
}, (error) => {
  dispatch(commonOperations.endRequest());
  console.log("axios.interceptors.request error");
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  dispatch(commonOperations.endRequest());
  debugLogResponse(response);
  return response;
}, (error, resolve, reject) => {
  dispatch(commonOperations.endRequest());
  if (config.apiStubFlag){
    debugLogResponse(error);
    return error;
  }
  console.log("axios.interceptors.response error");
  return Promise.reject(error);
});

var MainComponent = ({locale, messages}) => (
  <IntlProvider  defaultLocale={locale} locale={locale} key={locale} messages={messages}>
    <GlobalIntlProvider>
      <ContainerRouter />
    </GlobalIntlProvider>
  </IntlProvider>
);
MainComponent = connect(state => ({
  locale: state.style.locale,
  messages: localeMessages[state.style.locale],
}))(MainComponent);

ReactDOM.render(
  <Provider store={reduxStore}>
    <PersistGate loading={null} persistor={persistorStore}>
      <ConnectedRouter history={history}>
        <MainComponent />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
